import { DateTime } from 'luxon';

export const getIngredientBinGraphRanges = () => {
  const endTime = DateTime.now().toUTC();
  // DateTime.now().startOf('hour').minus({ hours : 2 }).toUTC();
  // if (window.DEMO_FROZEN_TIME) {
  //   endTime = DateTime.now().toUTC();
  // }

  return {
    start: endTime.minus({ days: 1 }).toISO(),
    end: endTime.toISO(),
  };
};
